import { IBrand } from "./../ibrand";

export const Brand: IBrand = {
  brandName: 'loro',
  navbarTitle: 'LoRo',
  brandTitle: 'LoRo',
  mockBackendUrl: 'https://si-test.preventor-player-ui-backend-mock.silabs.se',
  prodBackendUrl: '',
  dialogUrl: 'assets/dialogs/',
  targetOrigin: '*',
  defaultLocale: 'fr-CH',
  supportedLocales: ['fr-CH', 'de-CH'],
  messagesEnabled: true,
  showQuestionCounter: false,
  nextButtonInQuestion: false,
  resultLayout: 'separate',
  selfAssessmentFirst: false,
  tipsLayout: 'grid',
  cmsMockUrl: 'https://si-sandbox.orchard.silabs.se',
  cmsProdUrl: 'https://si-sandbox.orchard.silabs.se',
  cmsMockApiKey: 'ABCD1234',
  cmsProdApiKey: ''
};
